import { Gauge } from "lucide-react";

export default function Benchmark() {
  return (
    <div className="pt-[30px] pb-24 md:pb-[30px] px-4 md:px-[60px] bg-page-bg min-h-full" data-testid="benchmark-page">
      <h1 className="text-xl font-semibold text-page-title flex items-center gap-2">
        <Gauge size={20} /> Benchmark
      </h1>
    </div>
  );
}
